import type { ObjectFitType } from "@v1/types/object-fit";
import type { CustomPropDefinition } from "schemas/component";

import * as React from "react";

import ImageSourceSelector from "@v1/components/editor/page/element-editor/components/modifiers/ImageSourceSelector";
import useApplyComponentAction from "@v1/hooks/useApplyComponentAction";
import { styleAttributeToEditorData } from "@v1/utils/styleAttribute";

export const ImageCustomPropModifier = (props: {
  value?: { src: string; style: { objectFit?: ObjectFitType } };
  customPropId: string;
  definition: CustomPropDefinition;
}) => {
  const applyComponentAction = useApplyComponentAction();

  const _removeImageSrc = () => {
    applyComponentAction({
      type: "deleteProps",
      propName: props.customPropId,
    });
  };

  const allowsChangingObjectFit =
    props.definition.allowsSettingObjectFit ?? true;

  return (
    <ImageSourceSelector
      size="sm"
      src={props.value?.src}
      objectFitValue={
        props.value?.style?.objectFit ??
        styleAttributeToEditorData.objectFit.defaultValue
      }
      onChangeObjectFit={
        allowsChangingObjectFit
          ? (value: ObjectFitType) => {
              applyComponentAction({
                type: "setProps",
                value: {
                  [`${props.customPropId}`]: {
                    style: {
                      objectFit: value,
                    },
                  },
                },
              });
            }
          : undefined
      }
      onChangeImageSource={(value: string) => {
        applyComponentAction({
          type: "setProps",
          value: {
            [`${props.customPropId}`]: {
              src: value,
            },
          },
        });
      }}
      onRemove={_removeImageSrc}
    />
  );
};
